import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type FeatureFlagFragment = { name: string, value: string, type: Types.FlagValueTypeEnum };


export type FeatureFlagFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const FeatureFlagFragmentDoc = /*#__PURE__*/ gql`
    fragment FeatureFlag on FeatureFlagType {
  name
  value
  type
}
    `;